import React from "react"
import clsx from "clsx"
import { useTranslation } from "react-i18next"

import { LazyImage } from "components"
import { thousandSeparator } from "utils"
import classes from "./FoodModalHeader.module.scss"

const FoodModalHeader = props => {
  const {
    food,
    reduction,
    optionId,
    specificationItems
  } = props

  const [t, i18n] = useTranslation()

  const targetOption =
    food.options.find(o => o._id === optionId)

  if (!targetOption) return null

  const totalAddOns =
    specificationItems.reduce((t, si) => t += si.salePrice * (si.quantity - si.freeQuantity), 0)

  const realSalePrice =
    targetOption.salePrice +
    totalAddOns -
    reduction

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["header"]}>
      <LazyImage
        src={food.imageCover}
        imageWidth={100}
        quality={80}
        className={clsx(classes["image"], isLtr && classes["image-ltr"])}
      />

      <div className={classes["details"]}>
        <div className={classes["name"]}>
          {food.name}
        </div>
        <div className={classes["row"]}>
          <div
            className={clsx(
              classes["price"],
              reduction > 0 && classes["del"],
              reduction > 0 && isLtr && classes["del-ltr"],
            )}
          >
            {thousandSeparator(
              reduction > 0
                ? targetOption.salePrice
                : realSalePrice
            )}
          </div>
          {
            reduction > 0 &&
            <div className={classes["price"]}>
              {thousandSeparator(realSalePrice)}
            </div>
          }
        </div>
        {
          targetOption.outOfStock &&
          targetOption.stockManagement &&
          <div className={classes["qty"]}>
            {t("موجودی")}: {targetOption.availableQuantity}
          </div>
        }
      </div>
    </div>
  )
}

export default FoodModalHeader